<template>
  <div class="companyNews px-2 lg:px-0 p-10">
    <div class="companyNews-2">
      <div class="text-main text-4xl text-center font-semibold">{{ $t('news.companyNews.companyNewsDetail.title') }}
      </div>
      <div class=" w-14 h-0.5 text-center bg-black my-0 mx-auto mt-4"></div>
      <div class="text-gray-600 text-base text-center mt-10">{{ newsObj.title }}</div>
      <div class="pt-10 container mx-auto flex flex-col lg:flex-row h-full lg:pt-16">
        <img class="h-52" :src="$path + newsObj.image?.data?.attributes?.url" />
        <div class="flex-grow pl-2 pt-4 lg:pt-0 lg:pl-20 flex flex-col justify-between">
          <div class="text-menu-title font-semibold">{{ getMoment(newsObj.createdAt) }}</div>
          <div class="text-main font-semibold text-xl">{{ newsObj.title }}</div>
          <div class="text-gray-600 text-base">{{ newsObj.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue'
// import $ from 'jquery'
import { mapGetters } from 'vuex'
import { getNewsList } from '@/api/index'
import moment from 'moment'
export default {
  name: 'Home',
  data() {
    return {
      value: '',
      newsList: [],
      newsObj: {},
      xsShow: false, // 手机显示
      activeWidth: window.innerWidth
    }
  },
  watch: {
    activeWidth: {
      handler(val, oldVal) {
        if (val <= 416) {
          this.xsShow = true
        } else {
          this.xsShow = false
        }
      },
      deep: true, // true 深度监听
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      lang: 'getLang'
    }),
    lang() {
      return this.$store.state.lang
    }
  },
  components: {},
  created() {
    const { id } = this.$route.query
    this.getNewsList(id)
  },
  mounted() {
  },
  methods: {
    getMoment(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    async getNewsList(id) {
      const params = {
        'populate[image][fields]': 'url'
      }
      const result = await getNewsList(params, id)
      this.newsObj = result.data.attributes
    }
  }
}
</script>

<style lang="less" scoped>
.companyNews {
  background: #F9FAFB;

  .companyNews-1 {
    background-color: #fff;
    background-image: url("../../assets/images/home/advantage.svg");
    margin-bottom: 30px;
  }

  .companyNews-2 {
    margin-bottom: 80px;
  }
}

@media screen and (max-width: 768px) {
  .companyNews {}
}
</style>
